import React from 'react';
import ReactDOM from 'react-dom';
import Root from './containers/root';
import * as Sentry from '@sentry/browser';
import 'draft-js/dist/Draft.css';
import {versionManager} from './version_manager';
import DirectApi from './directApi';
import {Logger} from './Logger';

Logger.info(`using graphql server: ${DirectApi.graphqlServerEndpoint('graphql')}`);

if (process.env.SENTRY_CONFIG && process.env.SENTRY_CONFIG !== '') {
	Sentry.init({
		dsn: process.env.SENTRY_CONFIG,
		// https://docs.sentry.io/platforms/javascript/troubleshooting/
		tunnel: `${DirectApi.graphqlServerEndpoint('tunnel')}`,
		release: `web-front@${versionManager.getClientMajorVersion()}.${versionManager.getClientMinorVersion()}`,
		ignoreErrors: [
			"can't access dead object",
			'Method webWidget:on.open does not exist',
			'AbortError: The user aborted a request',
		],
	});
}

ReactDOM.render(<Root />, document.getElementById('app'));
